import React from "react";
import styled from "styled-components";

const TimeWrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  padding-bottom: 8rem;
`;

const TimeLabel = styled.span`
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;

  padding-top: 0.5rem;

  min-width: 3rem;

  text-align: center;

  font-size: 1rem;
  line-height: 1rem;
  font-weight: 700;

  color: white;

  z-index: 100;
`;

const BlackTriangle = styled.div`
  display: inline-block;
  box-sizing: border-box;

  position: absolute;
  top: -85px;
  right: -67px;
  vertical-align: middle;
  margin: 0 5px;

  border-bottom: solid 65px #000000;
  border-left: solid 65px #000000;
  border-top: solid 65px transparent;
  border-right: solid 65px transparent;

  width: 120px;
  height: 120px;

  transform: rotate(302deg);
  z-index: 50;
`;

const GreenTriangle = styled.div`
  display: inline-block;
  box-sizing: border-box;

  position: absolute;
  top: -26px;
  right: -12px;
  vertical-align: middle;
  margin: 0 5px;

  border-bottom: solid 48px #00da06;
  border-left: solid 48px #00da06;
  border-top: solid 48px transparent;
  border-right: solid 48px transparent;

  width: 70px;
  height: 70px;

  transform: rotate(-13deg);
  z-index: 10;
`;

export default class Logo extends React.Component {
  render() {
    return (
      <TimeWrapper>
        <TimeLabel>{this.props.text}</TimeLabel>
        <BlackTriangle />
        <GreenTriangle />
      </TimeWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/Logo.js